export const BOARD_SIZE = 4;

export const THEME = {
  pageBackground: '#faf8ef',
  primaryText: '#776e65',
  buttonNormal: '#8f7a66',
  buttonHover: '#9f8a76',
  boardBg: '#bbada0',
  scorePanelBg: '#bbada0',
  scoreLabel: '#eee4da',
};

export const TILE_COLORS = {
  0: { bg: 'rgba(238, 228, 218, 0.35)', color: 'transparent', fontSize: '55px' },
  2: { bg: '#eee4da', color: '#776e65', fontSize: '55px' },
  4: { bg: '#ede0c8', color: '#776e65', fontSize: '55px' },
  8: { bg: '#f2b179', color: '#f9f6f2', fontSize: '55px' },
  16: { bg: '#f59563', color: '#f9f6f2', fontSize: '55px' },
  32: { bg: '#f67c5f', color: '#f9f6f2', fontSize: '55px' },
  64: { bg: '#f65e3b', color: '#f9f6f2', fontSize: '55px' },
  128: { bg: '#edcf72', color: '#f9f6f2', fontSize: '45px' },
  256: { bg: '#edcc61', color: '#f9f6f2', fontSize: '45px' },
  512: { bg: '#edc850', color: '#f9f6f2', fontSize: '45px' },
  1024: { bg: '#edc53f', color: '#f9f6f2', fontSize: '35px' },
  2048: { bg: '#edc22e', color: '#f9f6f2', fontSize: '35px' },
};

export const FALLBACK_TILE = { 
  bg: '#3c3a32', 
  color: '#f9f6f2', 
  fontSize: '30px' 
};